import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { useRouter } from '../';
var LinkWrapper = function (_a, ref) {
    var path = _a.path, query = _a.query, _b = _a.spa, spa = _b === void 0 ? true : _b, _c = _a.scroll, scroll = _c === void 0 ? true : _c, onClick = _a.onClick, Children = _a.children, props = __rest(_a, ["path", "query", "spa", "scroll", "onClick", "children"]);
    var router = useRouter();
    var href = router.buildURI(path, query || {});
    var handleClick = function (e) {
        if (onClick) {
            onClick(e, { path: path, query: query });
        }
        e.preventDefault();
        router.push(href, { scroll: scroll, spa: spa });
    };
    var isElement = React.isValidElement(Children);
    var element = Children; // only text children, like <Link>home page</Link>
    if (isElement) {
        element = React.cloneElement(Children, // handle <Link><p>home page</p></Link>
        { ref: ref });
    }
    return (React.createElement("a", __assign({ onClick: handleClick, href: href }, props), element));
};
export default forwardRef(LinkWrapper);
//# sourceMappingURL=Link.js.map